import {KatalWeblabClient, BrowserStorageCache} from '@amzn/katal-weblab';
import {KatalWebSellerCentralClient} from '@amzn/katal-weblab-sellercentral';

import WeblabTreatment from "src/model/WeblabTreatment";
import RevCalMetricsUtil from "src/utils/RevCalMetricsUtil";

/**
 * Uses the browser's built in Session Storage to provide a cache that can survive page reloads and navigations.
 * This cache will be cleared once the browser tab or window is closed.
 */
const cacheTTLSeconds = 10 * 60; // 10 minutes * 60 seconds

/**
 * This information is required from each weblab when using the SellerCentralWeblabClient to call the Mons Proxy.
 * The proxy works by reading the Mons Context for you and setting the CustomerId, MerchantId, and Session.
 */
enum WeblabType {
    CUSTOMER = 'customer',
    MERCHANT = 'merchant',
    SESSION = 'session'
}

export const weblabClient = new KatalWeblabClient({
    metricsPublisher: RevCalMetricsUtil.getMetricsPublisher(),
    weblabProxy: new KatalWebSellerCentralClient(),
    treatmentCache: new BrowserStorageCache('RevCal', cacheTTLSeconds)
});

export function getWeblabList() {
    return [
        {
            // weblab for Revenue Calculator 1.0 login version deprecation
            defaultTreatment: 'C',
            id: 'REV_CAL_1_DEPRECATE_LOGIN_507134',
            weblabType: WeblabType.MERCHANT
        },
        {
            // weblab for Revenue Calculator 1.0 non-login version deprecation
            defaultTreatment: 'C',
            id: 'REV_CAL_1_DEPRECATE_NONLOGIN_507136',
            weblabType: WeblabType.SESSION
        }
    ];
}

export function callWeblabTreatments() {
    let weblabList = getWeblabList();

    return weblabClient.getTreatments(weblabList).then(treatments => {
        let weblabTreatments: WeblabTreatment[] = [];

        weblabList.forEach(weblab => {
            if (treatments[weblab.id].treatmentValue === 'T1') {
                weblabTreatments.push({weblabId: weblab.id, treatment: 'T1'});
            } else if (treatments[weblab.id].treatmentValue === 'T2') {
                weblabTreatments.push({weblabId: weblab.id, treatment: 'T2'});
            } else {
                weblabTreatments.push({weblabId: weblab.id, treatment: 'C'});
            }
        });

        return weblabTreatments;
    });
}

export const getWeblab = (availableWeblabs: WeblabTreatment[], name: string): string => {
    let weblab = availableWeblabs.find(weblab => weblab.weblabId === name);

    return weblab ? weblab.treatment : 'C';
};
